var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 18 22"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","d":"M15.3 12.8a2.7 2.7 0 0 1 2.7 2.7v.644c0 3.219-3.789 5.656-9 5.656s-9-2.31-9-5.656V15.5a2.7 2.7 0 0 1 2.7-2.7zM9 .2A5.4 5.4 0 1 1 9 11 5.4 5.4 0 0 1 9 .2"}})])
}
var staticRenderFns = []

export default { render: render }